import React from 'react';
import styled from 'styled-components';
import { SortArrow } from "../icons/SortArrow";

const StyledColumnTitle = styled.span`
    display: flex;
    align-items: center;
    height: 16px;
    
    & span {
        color: ${({sorted}) => sorted ? "var(--sp-main-color)" : "#8898B2"};
    }

    & span:not(:last-child) {
        margin-right: 4px;
    }
`;

const ColumnTitle = (sortOrder, sortColumn, dataIndex, title) => {
    let sorted = sortColumn && sortColumn.dataIndex == dataIndex && sortOrder;
    return(
        <StyledColumnTitle sorted={sorted}>
            <span>{title}</span>
            {sorted ? <SortArrow rotate={ sortOrder == "ascend" ? 180 : 0 } /> : null}
        </StyledColumnTitle>
    )
}

export { ColumnTitle }
